<template>
  <div class="person-box">
    <van-steps active-color="#228ccd" :active="active">
      <van-step>账号信息</van-step>
      <van-step>基本信息</van-step>
      <van-step>联系信息</van-step>
      <van-step>注册完成</van-step>
    </van-steps>
    <div class="content">
      <step-account @sendActive="setActive" @updateInfo="updateMember" v-if="active === 0"></step-account>
      <step-base @sendActive="setActive" v-else-if="active === 1" :member="member"></step-base>
      <step-contact @sendActive="setActive" v-else-if="active === 2" :member="member"></step-contact>
      <step-successed v-else></step-successed>
    </div>
  </div>
</template>

<script>
import { Step, Steps } from "vant";
import stepAccount from "./account";
import stepBase from "./base";
import stepContact from "./contact";
import stepSuccessed from "./successed";

export default {
  data() {
    return {
      active: 0,
      member: {}
    };
  },
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    stepAccount,
    stepBase,
    stepContact,
    stepSuccessed
  },
  methods: {
    setActive(value) {
      this.active = value;
    },
    updateMember(value) {
      this.member = value;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  margin-top: 15px;
}
/deep/.van-step--horizontal .van-step__title{ font-size:14px; }
/deep/.van-step--horizontal .van-step__icon{ font-size:15px;}
</style>
